// extracted by mini-css-extract-plugin
export default {"tooltip":"Dq-z","sharingV2":"Eq-z","sharingIconsV2":"Fq-z","links":"Gq-z","link":"Hq-z","facebookV2":"Iq-z","twitterV2":"Jq-z","pinterestV2":"Kq-z"};